import React from "react";
import { Helmet } from "react-helmet";
import GleaminGallery from "../components/GleaminGallery";

function Gleamin() {
  return (
    <div>
      <Helmet>
        <title>Gleamin — Octavio Garcia</title>
      </Helmet>

      <GleaminGallery />
    </div>
  );
}

export default Gleamin;
